/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { QueueActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        queue: state.queue
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getQueue: (data) => {
            dispatch(QueueActions.fetchQueue(data));
        },
        updateQueueOrder: (id, items) => {
            dispatch(QueueActions.updateQueueOrder(id, items));
        },
        deleteQueue: (id, items, hammertime) => {
            dispatch(QueueActions.deleteQueue(id, items, hammertime));
        },
        updateQueue: (id, item) => {
            dispatch(QueueActions.updateQueue(id, item));
        },
        getCalendar: (data) => {
            dispatch(QueueActions.fetchCalendar(data));
        },
        getCalendarDetail: (data) => {
            let detailData = Object.assign({}, data, {detailFlag: true});
            dispatch(QueueActions.fetchCalendarDetail(detailData));
        }
	};
}

export default function QueueProvider(Component) {

    class QueueProvider extends React.Component {
        render() {
            return (
                <Component {...this.props}/>
            );
        }
    }

    QueueProvider.displayName = "QueueProvider";

    return connect(mapStateToProps, mapDispatchToProps)(QueueProvider);
};
